import { Card, Container, Flex } from 'theme-ui';
import React from 'react';
import { MetabaseWeeklySales } from './MetabaseWeeklySales';
import { ResetDemoAccounts } from './ResetDemoAccounts';

interface Props {}

const FavoriteActions: React.FC<Props> = (props) => {
    return (
        <Container>
            <Flex sx={{ gap: 3, flexDirection: 'column' }}>
                <Card variant="widget" p={3}>
                    <MetabaseWeeklySales />
                </Card>
                <Card variant="widget" p={3}>
                    <ResetDemoAccounts />
                </Card>
            </Flex>
        </Container>
    );
};

export default FavoriteActions;
